import React, { Component } from "react";
import { get as _get, cloneDeep as _cloneDeep, isEqual as _isEqual, isEmpty as _isEmpty } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { Typeahead } from 'react-bootstrap-typeahead';
import { connect } from "react-redux";

import { Select, CustomModal, ErrorMessage, showAlertMessage } from "../../resusableComponents/common/formElements";

import { doGetAssetTypeList, getAssetsDetails, doGetTopicList, doGetSubTopicList } from "../../redux/services/campaignSetup";
import { createAssetsWithExisting } from "../../redux/services/campaign";
import { updateLoadingState } from "../../redux/actions/application";

class EditAsset extends Component {

  constructor(props) {
    super(props);

    this.defaultAssetState = {
      typeId: null,
      topic: [],
      subTopic: [],
      name: "",
      fileName: "",
      assetCode: "",
      url: "",
      azureUrl: "",
      rawJson: ""
    }

    this.state = {
      newAsset: _cloneDeep(this.defaultAssetState),
      errors: {},
      topicList: [],
      subTopicList: [],
      assetTypeList: [],
    };
  }

  async componentDidUpdate(prevProps, prevStates) {
    if (!_isEqual(prevStates.newAsset, this.state.newAsset)) {
      this._handleValidation();
    }

    if (prevProps.isOpen !== this.props.isOpen) {
      const { isOpen } = this.props;

      if ((isOpen || false) === true) {

        await this._getTopicList();
        await this._getAssetTypeList();
      } else {
        this._resetCreateAssetForm();
      }
    }
  }

  _getTopicList = async () => {
    const { updateLoadingState } = this.props;

    try {

      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await doGetTopicList();

      if (_get(response, "flag", false) === true) {

        this.setState({ topicList: _get(response, "data", []) });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching topic list.")));
        this.setState({ topicList: [] });
      }
    } catch (error) {
      showAlertMessage((_get(error, "message", "Something went wrong while fetching topic list.")));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  _handleChange = (e, name) => {
    e.preventDefault();

    const { value } = (e.target || {});

    this.setState((prevState) => ({
      newAsset: {
        ...prevState.newAsset,
        [name]: value
      }
    }));
  }

  _handleValidation = () => {
    const { intl } = this.props;
    const { newAsset } = this.state;
    let errors = {};

    if (_isEqual(newAsset, this.defaultAssetState)) {
      this.setState({
        errors: {}
      });

      return false;
    }

    if (_isEmpty(newAsset.typeId)) {
      errors["typeId"] = intl.formatMessage({ id: "error.required", defaultMessage: "{field} is required." }, {
        field: intl.formatMessage({ id: "campaign_content.create_asset_modal.asset_type", defaultMessage: "asset type" })
      });
    }

    if (_isEmpty(newAsset.name)) {
      errors["name"] = intl.formatMessage({ id: "error.required", defaultMessage: "{field} is required." }, {
        field: intl.formatMessage({ id: "campaign_content.create_asset_modal.name", defaultMessage: "name" })
      });
    }

    if (_isEmpty(newAsset.topic)) {
      errors["topic"] = intl.formatMessage({ id: "error.required", defaultMessage: "{field} is required." }, {
        field: intl.formatMessage({ id: "campaign_content.create_asset_modal.topics", defaultMessage: "topics" })
      });
    }

    if (_isEmpty(newAsset.subTopic)) {
      errors["subTopic"] = intl.formatMessage({ id: "error.required", defaultMessage: "{field} is required." }, {
        field: intl.formatMessage({ id: "campaign_content.create_asset_modal.sub_topics", defaultMessage: "sub topics" })
      });
    }

    if (_isEmpty(newAsset.assetCode)) {
      errors["assetCode"] = intl.formatMessage({ id: "error.required", defaultMessage: "{field} is required." }, {
        field: intl.formatMessage({ id: "campaign_content.create_asset_modal.asset_code", defaultMessage: "asset code" })
      });
    }

    if (_isEmpty(newAsset.url)) {
      errors["url"] = intl.formatMessage({ id: "error.required", defaultMessage: "{field} is required." }, {
        field: intl.formatMessage({ id: "campaign_content.create_asset_modal.url", defaultMessage: "url" })
      });
    }

    this.setState({ errors });
  }

  _handleSave = async () => {
    try {
      const { clientId, selectedAssetIds, intl } = this.props;
      const { newAsset, errors } = this.state;

      if (((newAsset.assetCode || "") === "")) {
        showAlertMessage(intl.formatMessage({ id: "error.select_atleast_one", defaultMessage: "Please select at least one {field}." },
          { field: intl.formatMessage({ id: "asset", defaultMessage: "asset" }) }));
        return false;
      }

      if (!_isEmpty(errors)) {
        showAlertMessage(intl.formatMessage({ id: "error.please_fill_up_the_proper_details", defaultMessage: "Please fill up the proper details." }));
        return false;
      }

      let variables = {
        "campaign_assets": null,
        "client_id": (clientId || 0),
        "asset_name": (newAsset.name || ""),
        "asset_code": (newAsset.assetCode || ""),
        "asset_url": (newAsset.url || ""),
        "asset_file_name": (newAsset.fileName || ""),
        "topic": _get(newAsset, "topic[0].topic", _get(newAsset, "topic[0]", 0)),
        "sub_topic": _get(newAsset, "subTopic[0].sub_topic", _get(newAsset, "subTopic[0]", 0)),
        "type_id": _get(newAsset, "typeId.id", 0),
        "raw_json": _get(newAsset, "rawJson", ""),
        "asset_id": (((selectedAssetIds || []).length > 0) ? selectedAssetIds[0] : null)
      };

      const response = await createAssetsWithExisting(variables);

      if ((response.flag || false) === true) {

        this._resetCreateAssetForm(true);
        showAlertMessage(_get(response, "message", "Campaign asset details updated successfully."), "success");
      } else {

        showAlertMessage(_get(response, "message", "Something went wrong while creating assets."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while creating assets."));
    }
  }

  // Fetch subtopic by selected topic
  _fetchSubTopicsByTopic = async (topicId) => {
    const { updateLoadingState } = this.props;

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await doGetSubTopicList([topicId]);

      if ((response.flag || false) === true) {

        this.setState({ subTopicList: _get(response, "data", []) });
      } else {

        showAlertMessage(_get(response, "message", "Something went wrong while fetching sub topics."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching sub topics."));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  _getAssetTypeList = async () => {
    const { updateLoadingState } = this.props;

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await doGetAssetTypeList();

      if (_get(response, "flag", false) === true) {

        this.setState({ assetTypeList: _get(response, "data", []) },
          () => {
            this._getAssetsDetails();
          }
        );
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching topic list.")));
        this.setState({ assetTypeList: [] });
      }
    } catch (error) {
      showAlertMessage((_get(error, "message", "Something went wrong while fetching topic list.")));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  _getAssetsDetails = async () => {
    const { onClose, clientId, selectedAssetIds, campaignId, updateLoadingState, intl } = this.props;
    const { assetTypeList, topicList } = this.state;

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      if (_isEmpty(selectedAssetIds)) {
        showAlertMessage(intl.formatMessage({ id: "error.select_atleast_one_with_operation", defaultMessage: "Please select at least one {field} to {operation}." }, { field: "asset", operation: "edit" }));
        onClose();
        return false;
      } else if ((selectedAssetIds || []).length > 1) {

        showAlertMessage(intl.formatMessage({ id: "error.select_only_one", defaultMessage: "Please select only one {field}." }, {
          field: intl.formatMessage({ id: "asset", defaultMessage: "asset" }),
        }));
        onClose();
        return false;
      }

      const assetId = (((selectedAssetIds || []).length > 0) ? selectedAssetIds[0] : null);

      const response = await getAssetsDetails(clientId, { dropdown_flag: 0, asset_id: assetId, campaign_id: (campaignId || 0) });

      if (_get(response, "flag", false) === true) {
        const existingTopic = (topicList || []).find(item => item.topic === _get(response, "data[0].topic", ""));
        const existingAssetType = (assetTypeList || []).find(item => item.asset_type === _get(response, "data[0].asset_type", ""));
        const topic = { id: _get(response, "data[0].topic", ""), topic: _get(response, "data[0].topic", "") };
        const subTopic = { id: _get(response, "data[0].sub_topic", ""), sub_topic: _get(response, "data[0].sub_topic", "") };

        this.setState((prevState) => ({
          newAsset: {
            ...prevState.newAsset,
            typeId: existingAssetType,
            url: _get(response, "data[0].asset_url", ""),
            azureUrl: _get(response, "data[0].asset_url", ""),
            fileName: _get(response, "data[0].filename", ""),
            topic: [_get(response, "data[0].topic", "")],
            subTopic: [_get(response, "data[0].sub_topic", "")],
            rawJson: _get(response, "data[0].raw_json", ""),
            name: _get(response, "data[0].asset_name", ""),
            assetCode: _get(response, "data[0].asset_code", "")
          },
          topicList: (!_isEmpty(existingTopic)) ? topicList : [...topicList, topic],
          subTopicList: [subTopic],
        }));
      }
    } catch (error) {
      showAlertMessage((_get(error, "message", "Something went wrong while fetching assets details.")));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  _resetCreateAssetForm = (fetch = false) => {
    const { onClose } = this.props;

    this.setState({
      newAsset: _cloneDeep(this.defaultAssetState),
      errors: {},
    });

    if (typeof onClose === "function") {
      onClose(fetch)
    };
  }

  _renderModalBody = () => {
    const { intl } = this.props;
    const { newAsset, errors, topicList, subTopicList, assetTypeList, } = this.state;

    return (
      <div className="modalForm">
        <div className="row gutters-10">

          <div className="col-sm-6 col-md-6">
            <div className="mb-6">
              <label htmlFor="create_url" className="form-label text-capitalize">
                <FormattedMessage id="campaign_content.create_asset_modal.url" defaultMessage="url" />
              </label>
              <input
                id="create_url"
                name="create_url"
                className="form-control"
                value={(newAsset.url || "")}
                placeholder={intl.formatMessage({ id: "placeholder.enter_field", defaultMessage: "Enter {field}" }, {
                  field: intl.formatMessage({ id: "campaign_content.create_asset_modal.url", defaultMessage: "url" })
                })}
                onChange={(e) => this._handleChange(e, "url")}
                disabled={true}
              />
              {(errors.name !== "") && (<ErrorMessage message={(errors.url || "")} />)}
            </div>
          </div>

          <div className="col-sm-6 col-md-6">
            <div className="mb-6">
              <label className="form-label text-capitalize">
                <FormattedMessage id="campaign_content.create_asset_modal.asset_type" defaultMessage="asset type" />
              </label>

              <Select
                className="form-custom-select"
                placeholder={intl.formatMessage({ id: "placeholder.select_field", defaultMessage: "Select {field}" },
                  { field: intl.formatMessage({ id: "campaign_content.create_asset_modal.asset_type", defaultMessage: "asset type" }) })}
                value={(newAsset.typeId || null)}
                options={(assetTypeList || [])}
                error={(errors.typeId || "")}
                getOptionValue={(option) => (option.id)}
                getOptionLabel={(option) => (option.asset_type)}
                onChange={(selectedOptions) => this.setState((prevState) => ({
                  newAsset: {
                    ...prevState.newAsset,
                    typeId: selectedOptions
                  }
                }))}
                isMulti={false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6">
            <div className="mb-6">
              <label className="form-label text-capitalize">
                <FormattedMessage id="campaign_content.create_asset_modal.topics" defaultMessage="topics" />
              </label>
              <Typeahead
                id="custom-typeahead"
                placeholder={intl.formatMessage({ id: "placeholder.start_typing_to_search", defaultMessage: "start typing to search" })}
                newSelectionPrefix={intl.formatMessage({ id: "campaign_content.placeholder.create_new_topic", defaultMessage: "Click to create new topic: " })}
                allowNew
                labelKey="topic"
                selected={(newAsset.topic || "")}
                options={(topicList || []).map(option => _get(option, "topic", ""))}
                onChange={(selectedOptions) => {

                  if (selectedOptions.length > 0) {
                    const lastSelected = selectedOptions[selectedOptions.length - 1];

                    if (typeof lastSelected === 'string' && (topicList || []).some(option => option.topic === lastSelected)) {

                      // If Existing topic selected then fetch sub topics
                      const selectedOption = (topicList || []).find(option => option.topic === lastSelected);
                      if (selectedOption) {
                        this._fetchSubTopicsByTopic(_get(selectedOption, "id", 0));
                      }
                    }
                  }

                  this.setState((prevState) => ({
                    newAsset: {
                      ...prevState.newAsset,
                      topic: selectedOptions
                    }
                  }));

                }}
              />
              {(errors.topic !== "") && (<ErrorMessage message={(errors.topic || "")} />)}
            </div>
          </div>

          <div className="col-sm-6 col-md-6">
            <div className="mb-6">
              <label className="form-label text-capitalize">
                <FormattedMessage id="campaign_content.create_asset_modal.sub_topics" defaultMessage="sub topics" />
              </label>
              <Typeahead
                id="custom-typeahead"
                placeholder={intl.formatMessage({ id: "placeholder.start_typing_to_search", defaultMessage: "start typing to search" })}
                newSelectionPrefix={intl.formatMessage({ id: "campaign_content.placeholder.create_new_sub_topic", defaultMessage: "Click to create new sub topic: " })}
                allowNew
                labelKey="sub_topic"
                selected={(newAsset.subTopic || "")}
                options={(subTopicList || []).map(option => _get(option, "sub_topic", ""))}
                onChange={(selectedOptions) => {

                  this.setState((prevState) => ({
                    newAsset: {
                      ...prevState.newAsset,
                      subTopic: selectedOptions
                    }
                  }));

                }}
              />
              {(errors.subTopic !== "") && (<ErrorMessage message={(errors.subTopic || "")} />)}
            </div>
          </div>

          <div className="col-sm-6 col-md-6">
            <div className="mb-6">
              <label htmlFor="create_name" className="form-label text-capitalize">
                <FormattedMessage id="campaign_content.create_asset_modal.name" defaultMessage="name" />
              </label>

              <input
                id="create_name"
                name="create_name"
                className="form-control"
                value={(newAsset.name || "")}
                placeholder={intl.formatMessage({ id: "placeholder.enter_field", defaultMessage: "Enter {field}" }, {
                  field: intl.formatMessage({ id: "campaign_content.create_asset_modal.name", defaultMessage: "name" })
                })}
                onChange={(e) => this._handleChange(e, "name")}
              />
              {(errors.name !== "") && (<ErrorMessage message={(errors.name || "")} />)}
            </div>
          </div>

          <div className="col-sm-6 col-md-6">
            <div className="mb-6">
              <label htmlFor="create_code" className="form-label text-capitalize">
                <FormattedMessage id="campaign_content.create_asset_modal.asset_code" defaultMessage="asset code" />
              </label>
              <input
                id="create_code"
                name="create_code"
                className="form-control"
                value={(newAsset.assetCode || "")}
                placeholder={intl.formatMessage({ id: "placeholder.enter_field", defaultMessage: "Enter {field}" }, {
                  field: intl.formatMessage({ id: "campaign_content.create_asset_modal.asset_code", defaultMessage: "asset code" })
                })}
                onChange={(e) => this._handleChange(e, "assetCode")}
              />
              {(errors.assetCode !== "") && (<ErrorMessage message={(errors.assetCode || "")} />)}
            </div>
          </div>

          <div className="pt-4 px-4 mx-n4 d-flex gap-3 align-items-center justify-content-end border-top">
            <button className="btn btn-secondary" onClick={() => this._resetCreateAssetForm()}>
              <FormattedMessage id="btn.cancel" defaultMessage="Cancel" />
            </button>
            <button className="btn btn-primary text-capitalize" onClick={() => this._handleSave()}>
              <FormattedMessage id="btn.submit" defaultMessage="Submit" />
            </button>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { isOpen, intl, source = "campaign_content" } = this.props;

    if (source === "campaign_content") {
      return (
        <CustomModal
          isOpen={isOpen}
          size="lg"
          className="addContentModal"
          modalTitle={(intl.formatMessage({ id: "campaign_content.create_asset_modal.title", defaultMessage: "create asset" }))}
          onHide={() => this._resetCreateAssetForm()}
          onClose={() => this._resetCreateAssetForm()}
        >
          {this._renderModalBody()}
        </CustomModal>
      )
    }

    return (
      <>
        {this._renderModalBody()}
      </>
    );
  }
}

const mapStateToProps = (state, props) => ({
  allowedAssetFiles: _get(state, "application.constants.allowedAssetFiles", ""),
  allowedAssetFilesLabel: _get(state, "application.constants.allowedAssetFilesLabel", ""),
  clientsData: _get(state, "users.clients.data.clients", []),
});

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EditAsset));
